<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import ProductTile from './ProductTile'
import ProductTitleBar from './ProductTitleBar'
import ShoppingCart from './ShoppingCart'

export default {
  name: 'ShopModule',
  components: {
    ProductTile,
    ProductTitleBar,
    ShoppingCart,
  },
  props: {
    options: {
      type: Object,
      default: _ => {},
    },
  },
  data() {
    return {
      selectedOverlay: null,
    }
  },
  computed: {
    ...mapState('carts', ['cart' ]),
  },
  created() {
    this.getShoppingCart()
  },
  methods: {
    ...mapActions('carts', [
      'addProductToCart',
      'getShoppingCart',
    ]),
    closeOverlay() {
      this.selectedOverlay = null
    },
    async toggleShoppingCart(id) {
      this.selectedOverlay = 'shoppingCart'
      await this.addProductToCart(id)
    },
  },
}
</script>
